import React, { useState } from 'react';
import { Button, Input } from '@privemind/components';
import { portfolioStore } from '../../stores/portfolio-store';
import { isError } from '../../lib/utils/type-guards';
import './create-bucket-card.scss';

interface CreateBucketCardProps {
  onBucketCreated?: () => void;
}

export const CreateBucketCard: React.FC<CreateBucketCardProps> = ({
  onBucketCreated
}) => {
  const [bucketName, setBucketName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const createBucket = async () => {
    const name = bucketName.trim();
    if (!name) {
      setErrorMessage('Please enter a bucket name');
      return;
    }

    if (portfolioStore.bucketExists(name)) {
      setErrorMessage('Bucket already exists');
      return;
    }

    setIsLoading(true);
    try {
      const response = await portfolioStore.addBucket(name);
      if (isError(response)) {
        setErrorMessage(response.message || 'Failed to create bucket');
      } else {
        setBucketName('');
        setErrorMessage('');
        onBucketCreated?.();
      }
    } catch (error) {
      setErrorMessage('Failed to create bucket');
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="create-bucket-card">
      <div className="create-bucket-card__header">
        <h3 className="create-bucket-card__title">Create New Bucket</h3>
        <div className="create-bucket-card__icon">+</div>
      </div>
      
      <div className="create-bucket-card__content">
        <div className="create-bucket-card__form">
          <label>Bucket Name</label>
          <Input
            value={bucketName}
            onChange={setBucketName}
            placeholder="e.g., DeFi Tokens, Store of Value"
          />
          
          <Button 
            onClick={createBucket}
            disabled={isLoading}
          >
            {isLoading ? 'Creating...' : 'Create Bucket'}
          </Button>
        </div>
        
        {errorMessage && (
          <div className="create-bucket-card__error">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};
